/**
 * Club de Profesores — matriz, carrito, reorden y analítica.
 * El precio y el descuento mostrados son solo visuales; el cobro lo calcula Shopify.
 */
(function () {
  if (window.__clubBound) return;
  window.__clubBound = true;


  function publish(name, data) {
    var payload = data || {};
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
      Shopify.analytics.publish(name, payload);
    }
  }

  function readMoneyFormat() {
    var node = document.getElementById("odk-cart-config");
    if (!node) return "${{amount}}";
    try {
      var parsed = JSON.parse(node.textContent);
      return parsed.moneyFormat || "${{amount}}";
    } catch (e) {
      return "${{amount}}";
    }
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var n = Number(number);
    var p = precision == null ? 2 : precision;
    var t = thousands == null ? "," : thousands;
    var d = decimal == null ? "." : decimal;
    if (!isFinite(n) || !isFinite(p)) return "0";
    var fixed = n.toFixed(p).split(".");
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
    var cents = fixed[1] ? d + fixed[1] : "";
    return whole + cents;
  }

  function formatMoney(cents) {
    var format = readMoneyFormat();
    var value = Number(cents);
    if (!isFinite(value)) value = 0;
    var amount = value / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case "amount_no_decimals":
          return formatWithDelimiters(amount, 0, ",", ".");
        case "amount_with_comma_separator":
          return formatWithDelimiters(amount, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return formatWithDelimiters(amount, 0, ".", ",");
        case "amount_with_apostrophe_separator":
          return formatWithDelimiters(amount, 2, "'", ".");
        case "amount_with_space_separator":
          return formatWithDelimiters(amount, 2, " ", ",");
        case "amount_no_decimals_with_space_separator":
          return formatWithDelimiters(amount, 0, " ", ",");
        default:
          return formatWithDelimiters(amount, 2, ",", ".");
      }
    });
  }

  function cartCountFromDom() {
    var root = document.querySelector("[data-club-cart-count]");
    if (!root) return 0;
    var count = Number(root.getAttribute("data-club-cart-count"));
    return isFinite(count) ? count : 0;
  }

  function setCartCount(count) {
    document.querySelectorAll("[data-club-cart-count]").forEach(function (node) {
      node.setAttribute("data-club-cart-count", String(count));
    });
    refreshMatrices();
  }

  function refreshMatrices() {
    document.querySelectorAll("[data-club-matrix]").forEach(refreshMatrix);
  }

  function fill(template, values) {
    var text = template || "";
    Object.keys(values).forEach(function (key) {
      text = text.split("[" + key + "]").join(String(values[key]));
    });
    return text;
  }

  function stringsFrom(root) {
    return {
      pieces: root.getAttribute("data-s-pieces") || "{{ count }} × {{ price }}",
      discount: root.getAttribute("data-s-discount") || "",
      shipping: root.getAttribute("data-s-shipping") || "",
      added: root.getAttribute("data-s-added") || "",
      error: root.getAttribute("data-s-error") || "",
      saved: root.getAttribute("data-s-saved") || "",
      add: root.getAttribute("data-s-add") || "",
      addPlain: root.getAttribute("data-s-add-plain") || "",
      omitted: root.getAttribute("data-s-omitted") || ""
    };
  }

  function matrixInputs(matrix) {
    return Array.prototype.slice.call(matrix.querySelectorAll("[data-variant-id]"));
  }

  function qtyOf(input) {
    var value = parseInt(input.value, 10);
    if (!isFinite(value) || value < 0) return 0;
    if (value > 999) return 999;
    return value;
  }

  function refreshMatrix(matrix) {
    var inputs = matrixInputs(matrix);
    var rows = Array.prototype.slice.call(matrix.querySelectorAll("[data-club-row]"));
    var colTotals = [];
    var grand = 0;
    var subtotal = 0;

    rows.forEach(function (row) {
      var rowQty = 0;
      var cells = Array.prototype.slice.call(row.querySelectorAll("[data-variant-id]"));
      cells.forEach(function (input, index) {
        var qty = qtyOf(input);
        input.classList.toggle("is-filled", qty > 0);
        rowQty += qty;
        colTotals[index] = (colTotals[index] || 0) + qty;
        grand += qty;
        subtotal += qty * (Number(input.getAttribute("data-price")) || 0);
      });
      var rowTotal = row.querySelector("[data-club-row-total]");
      if (rowTotal) rowTotal.textContent = String(rowQty);
    });

    Array.prototype.slice.call(matrix.querySelectorAll("[data-club-col-total]")).forEach(function (cell, index) {
      cell.textContent = String(colTotals[index] || 0);
    });
    var grandCell = matrix.querySelector("[data-club-grand-total]");
    if (grandCell) grandCell.textContent = String(grand);

    var copy = stringsFrom(matrix.closest("[data-club-copy]") || matrix);
    var holder = matrix.closest("[data-club-discount]");
    var percent = holder ? Number(holder.getAttribute("data-club-discount")) || 0 : 0;
    var total = subtotal - Math.round(subtotal * (percent / 100));
    var unit = grand ? Math.round(subtotal / grand) : 0;
    var summary = matrix.querySelector("[data-club-summary]");
    if (summary) {
      summary.innerHTML =
        "<p>" + fill(copy.pieces, { count: grand, price: formatMoney(unit) }) + "</p>" +
        (percent > 0 ? "<p>" + fill(copy.discount, { percent: percent }) + "</p>" : "") +
        "<p>" + copy.shipping + "</p>" +
        "<p><strong class=\"club-price\">" + formatMoney(total) + "</strong></p>";
    }

    var add = matrix.querySelector("[data-club-add]");
    var sticky = document.querySelector("[data-club-sticky-add]");
    var label = fill(copy.add, { count: grand });
    if (add) add.textContent = grand > 0 ? label : (copy.addPlain || add.textContent);
    if (sticky && matrix.hidden === false) {
      sticky.hidden = grand < 1;
      var stickyBtn = sticky.querySelector("button");
      if (stickyBtn) stickyBtn.textContent = label;
    }
    matrix.setAttribute("data-pieces", String(grand));
  }

  function selectedItems(matrix) {
    var items = [];
    var listName = "";
    var nameInput = matrix.querySelector("[data-club-list-name]");
    if (nameInput && nameInput.value.trim()) listName = nameInput.value.trim();
    matrixInputs(matrix).forEach(function (input) {
      var qty = qtyOf(input);
      if (qty < 1) return;
      var item = {
        id: Number(input.getAttribute("data-variant-id")),
        quantity: qty
      };
      if (listName) item.properties = { _Lista: listName };
      items.push(item);
    });
    return { items: items, listName: listName };
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          var error = new Error((data && (data.description || data.message)) || "Error");
          error.payload = data;
          throw error;
        });
      }
      return response.json();
    });
  }

  function addOneByOne(items) {
    var omitted = [];
    var chain = Promise.resolve();
    items.forEach(function (item) {
      chain = chain.then(function () {
        return postJson("/cart/add.js", { items: [item] }).catch(function () {
          omitted.push(String(item.id));
        });
      });
    });
    return chain.then(function () {
      return omitted;
    });
  }

  function openCart() {
    if (window.CartDrawer && typeof window.CartDrawer.refresh === "function") {
      var pending = window.CartDrawer.refresh();
      if (pending && typeof pending.then === "function") {
        return pending.then(function () {
          if (typeof window.CartDrawer.open === "function") window.CartDrawer.open();
        });
      }
    }
    if (window.CartDrawer && typeof window.CartDrawer.open === "function") window.CartDrawer.open();
    return Promise.resolve();
  }

  function refreshCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count || 0);
        return cart;
      });
  }

  function showError(matrix, text) {
    var node = matrix.querySelector("[data-club-error]");
    if (!node) return;
    if (!text) {
      node.hidden = true;
      node.textContent = "";
      return;
    }
    node.hidden = false;
    node.textContent = text;
  }

  function addMatrix(matrix) {
    var pack = selectedItems(matrix);
    if (!pack.items.length) return;
    var copy = stringsFrom(matrix.closest("[data-club-copy]") || matrix);
    var lines = pack.items.length;
    showError(matrix, "");
    var button = matrix.querySelector("[data-club-add]");
    if (button) button.disabled = true;

    postJson("/cart/add.js", { items: pack.items })
      .then(function () {
        return [];
      })
      .catch(function () {
        return addOneByOne(pack.items);
      })
      .then(function (omitted) {
        var failed = omitted || [];
        var added = pack.items.filter(function (item) {
          return failed.indexOf(String(item.id)) === -1;
        });
        if (!added.length) {
          showError(matrix, copy.error);
          return null;
        }
        var update = Promise.resolve();
        if (pack.listName) {
          update = postJson("/cart/update.js", { attributes: { Lista: pack.listName } });
        }
        return update.then(function () {
          return failed;
        });
      })
      .then(function (omitted) {
        if (!omitted) return;
        var addedPieces = pack.items.reduce(function (sum, item) {
          if (omitted.indexOf(String(item.id)) !== -1) return sum;
          return sum + item.quantity;
        }, 0);
        publish("club_pedido_grupo_agregado", {
          piezas: addedPieces,
          lineas: lines
        });
        matrixInputs(matrix).forEach(function (input) {
          if (omitted.indexOf(String(input.getAttribute("data-variant-id"))) === -1) {
            if (qtyOf(input) > 0) input.value = "0";
          }
        });
        refreshMatrix(matrix);
        if (omitted.length) showError(matrix, copy.error);
        return refreshCount().then(openCart);
      })
      .catch(function () {
        showError(matrix, copy.error);
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  }

  function listsData() {
    var node = document.querySelector("[data-club-lists]");
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function fillListSelects() {
    var lists = listsData();
    document.querySelectorAll("[data-club-load-list]").forEach(function (select) {
      var matrix = select.closest("[data-club-matrix]");
      var productId = matrix ? String(matrix.getAttribute("data-product-id")) : "";
      var current = select.value;
      while (select.options.length > 1) select.remove(1);
      lists.forEach(function (list, index) {
        if (list.productId && productId && String(list.productId) !== productId) return;
        var option = document.createElement("option");
        option.value = String(index);
        option.textContent = list.name || String(index + 1);
        select.appendChild(option);
      });
      if (current) select.value = current;
    });
  }

  function applyList(matrix, list) {
    var counts = {};
    (list.entries || []).forEach(function (entry) {
      var key = String(entry.color || "").toLowerCase() + "|" + String(entry.size || "").toLowerCase();
      counts[key] = (counts[key] || 0) + (Number(entry.qty) || 1);
    });
    matrixInputs(matrix).forEach(function (input) {
      var key = String(input.getAttribute("data-color") || "").toLowerCase() + "|" + String(input.getAttribute("data-size") || "").toLowerCase();
      input.value = counts[key] ? String(counts[key]) : "0";
    });
    var nameInput = matrix.querySelector("[data-club-list-name]");
    if (nameInput && list.name) nameInput.value = list.name;
    refreshMatrix(matrix);
  }

  function saveList(matrix) {
    var nameInput = matrix.querySelector("[data-club-list-name]");
    var name = nameInput && nameInput.value.trim() ? nameInput.value.trim() : matrix.getAttribute("data-product-title");
    var rows = [];
    matrixInputs(matrix).forEach(function (input) {
      var qty = qtyOf(input);
      if (qty < 1) return;
      rows.push({
        color: input.getAttribute("data-color") || "",
        size: input.getAttribute("data-size") || "",
        qty: qty
      });
    });
    if (!rows.length) return;
    var stored = [];
    try {
      stored = JSON.parse(window.localStorage.getItem("odaki.club.lists") || "[]");
    } catch (e) {
      stored = [];
    }
    if (!Array.isArray(stored)) stored = [];
    stored.push({
      name: name,
      productId: matrix.getAttribute("data-product-id"),
      rows: rows,
      savedAt: new Date().toISOString()
    });
    try {
      window.localStorage.setItem("odaki.club.lists", JSON.stringify(stored));
    } catch (e) { /* almacenamiento lleno o bloqueado */ }

    var form = document.querySelector("[data-club-list-form]");
    if (form && form.tagName !== "FORM") form = form.querySelector("form");
    var body = form && form.querySelector("[data-club-list-body]");
    if (form && body) {
      var lines = rows.map(function (row) {
        return row.color + " · " + row.size + " · " + row.qty;
      });
      body.value = name + "\n" + matrix.getAttribute("data-product-title") + "\n" + lines.join("\n");
      var data = new FormData(form);
      fetch(form.action, { method: "POST", body: data, headers: { Accept: "text/html" } }).catch(function () {});
    }
    publish("club_lista_guardada", {});
    var copy = stringsFrom(matrix.closest("[data-club-copy]") || matrix);
    showError(matrix, "");
    var summary = matrix.querySelector("[data-club-summary]");
    if (summary && copy.saved) {
      var note = document.createElement("p");
      note.textContent = copy.saved;
      summary.appendChild(note);
    }
  }

  function openMatrix(id) {
    var opened = null;
    document.querySelectorAll("[data-club-matrix]").forEach(function (matrix) {
      var match = matrix.getAttribute("data-product-id") === String(id);
      matrix.hidden = !match;
      if (match) opened = matrix;
    });
    if (!opened) return;
    publish("club_matriz_abierta", { producto: opened.getAttribute("data-product-handle") });
    refreshMatrix(opened);
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    opened.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }

  function mergeItems(items) {
    var map = {};
    var order = [];
    items.forEach(function (item) {
      var key = String(item.id);
      if (!map[key]) {
        map[key] = { id: Number(item.id), quantity: 0 };
        if (item.properties) map[key].properties = item.properties;
        order.push(key);
      }
      map[key].quantity += Number(item.quantity) || 0;
    });
    return order.map(function (key) { return map[key]; });
  }

  function reorder(button) {
    var raw = button.getAttribute("data-club-items") || "[]";
    var omittedText = button.getAttribute("data-club-omitted") || "";
    var origin = button.getAttribute("data-club-origin") || "pedidos";
    var items = [];
    try {
      items = JSON.parse(raw);
    } catch (e) {
      items = [];
    }
    items = mergeItems(items);
    if (!items.length && !omittedText) return;
    button.disabled = true;
    var live = document.querySelector("[data-club-live]");
    var finish = function (extra) {
      publish("club_reorden", { origen: origin });
      var message = [omittedText, extra].filter(Boolean).join(" ");
      if (live && message) live.textContent = message;
      refreshCount().then(openCart).then(function () {
        button.disabled = false;
      });
    };
    if (!items.length) {
      finish("");
      return;
    }
    postJson("/cart/add.js", { items: items })
      .then(function () { finish(""); })
      .catch(function () {
        addOneByOne(items).then(function (failed) {
          var extra = failed.length ? button.getAttribute("data-club-failed") || "" : "";
          finish(extra);
        });
      });
  }

  function bind() {
    document.querySelectorAll("[data-club-view]").forEach(function (node) {
      var name = node.getAttribute("data-club-view");
      if (name && node.getAttribute("data-club-viewed") !== "true") {
        node.setAttribute("data-club-viewed", "true");
        publish(name, {});
      }
    });

    document.addEventListener("click", function (event) {
      var analytics = event.target.closest("[data-club-event]");
      if (analytics) {
        var extra = {};
        var raw = analytics.getAttribute("data-club-event-data");
        if (raw) {
          try { extra = JSON.parse(raw); } catch (e) { extra = {}; }
        }
        publish(analytics.getAttribute("data-club-event"), extra);
      }

      var tab = event.target.closest("[data-club-tab]");
      if (tab) {
        var root = tab.closest("[data-club-tabs]");
        if (!root) return;
        root.querySelectorAll("[data-club-tab]").forEach(function (item) {
          var on = item === tab;
          item.classList.toggle("is-active", on);
          item.setAttribute("aria-selected", on ? "true" : "false");
        });
        root.querySelectorAll("[data-club-panel]").forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-club-panel") !== tab.getAttribute("data-club-tab");
        });
      }

      var opener = event.target.closest("[data-club-open-matrix]");
      if (opener) {
        openMatrix(opener.getAttribute("data-club-open-matrix"));
      }

      var closer = event.target.closest("[data-club-close-matrix]");
      if (closer) {
        var matrix = closer.closest("[data-club-matrix]");
        if (matrix) matrix.hidden = true;
        var sticky = document.querySelector("[data-club-sticky-add]");
        if (sticky) sticky.hidden = true;
      }

      var add = event.target.closest("[data-club-add]");
      if (add) {
        var host = add.closest("[data-club-matrix]") || document.querySelector("[data-club-matrix]:not([hidden])");
        if (host) addMatrix(host);
      }

      var save = event.target.closest("[data-club-save-list]");
      if (save) {
        var saveHost = save.closest("[data-club-matrix]");
        if (saveHost) saveList(saveHost);
      }

      var repeat = event.target.closest("[data-club-reorder]");
      if (repeat) reorder(repeat);

      var more = event.target.closest("[data-club-more]");
      if (more) {
        var table = document.getElementById(more.getAttribute("aria-controls"));
        if (table) {
          table.querySelectorAll("[hidden]").forEach(function (row) { row.hidden = false; });
          more.hidden = true;
        }
      }

      var filtersBtn = event.target.closest("[data-club-open-filters]");
      if (filtersBtn) {
        var drawer = document.querySelector("[data-club-filter-drawer]");
        if (drawer) {
          drawer.classList.add("is-open");
          filtersBtn.setAttribute("aria-expanded", "true");
        }
      }

      var closeFilters = event.target.closest("[data-club-close-filters]");
      if (closeFilters) {
        var panel = document.querySelector("[data-club-filter-drawer]");
        if (panel) panel.classList.remove("is-open");
        var openerBtn = document.querySelector("[data-club-open-filters]");
        if (openerBtn) openerBtn.setAttribute("aria-expanded", "false");
      }

      var orderFilter = event.target.closest("[data-club-filter]");
      if (orderFilter) {
        var group = orderFilter.closest("[data-club-order-tools]");
        if (!group) return;
        group.querySelectorAll("[data-club-filter]").forEach(function (item) {
          var on = item === orderFilter;
          item.classList.toggle("is-active", on);
          item.setAttribute("aria-pressed", on ? "true" : "false");
        });
        applyOrderFilters();
      }
    });

    document.addEventListener("input", function (event) {
      var input = event.target.closest("[data-variant-id]");
      if (!input) return;
      var matrix = input.closest("[data-club-matrix]");
      if (matrix) refreshMatrix(matrix);
    });

    document.addEventListener("change", function (event) {
      var select = event.target.closest("[data-club-load-list]");
      if (select) {
        var lists = listsData();
        var list = lists[Number(select.value)];
        var matrix = select.closest("[data-club-matrix]");
        if (list && matrix) applyList(matrix, list);
      }

      var year = event.target.closest("[data-club-year]");
      if (year) applyOrderFilters();

      var sort = event.target.closest("[data-club-sort]");
      if (sort) {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sort.value);
        window.location.assign(url.toString());
      }

      var filterForm = event.target.closest("[data-club-filter-form]");
      if (filterForm && event.target !== filterForm.querySelector("[data-club-sort]")) {
        if (event.target.closest("[data-club-sort]")) return;
        filterForm.submit();
      }
    });

    document.addEventListener("cart:updated", function (event) {
      var count = event.detail && typeof event.detail.item_count === "number" ? event.detail.item_count : null;
      if (count == null) {
        refreshCount();
      } else {
        setCartCount(count);
      }
    });

    var register = document.querySelector("[data-club-register]");
    if (register) {
      register.addEventListener("submit", function () {
        publish("club_registro_enviado", {});
      });
    }

    fillListSelects();
    refreshMatrices(cartCountFromDom());
  }

  function applyOrderFilters() {
    var tools = document.querySelector("[data-club-order-tools]");
    if (!tools) return;
    var active = tools.querySelector("[data-club-filter].is-active");
    var status = active ? active.getAttribute("data-club-filter") : "all";
    var yearSelect = tools.querySelector("[data-club-year]");
    var year = yearSelect ? yearSelect.value : "all";
    document.querySelectorAll("[data-club-order]").forEach(function (row) {
      var rowStatus = row.getAttribute("data-status");
      var rowYear = row.getAttribute("data-year");
      var statusOk = status === "all" || rowStatus === status || (status === "progress" && rowStatus === "transit");
      var yearOk = year === "all" || rowYear === year;
      row.hidden = !(statusOk && yearOk);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
